import React from 'react'
import PropTypes from 'prop-types'
import { useAuthorization } from '../../containers/AuthorizationProvider/AuthorizationProvider.hooks'

/**
 * The Private Section's component.
 */
const PrivateSection = props => {
  const { children, fallback, rule } = props
  const { isPrivated } = useAuthorization()
  const result = rule(isPrivated)

  if (!result) {
    return fallback(isPrivated)
  }

  return <>{children}</>
}

PrivateSection.defaultProps = {
  fallback: () => null,
  redirectTo: '',
  rule: isPrivated => isPrivated
}
PrivateSection.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.func,
  rule: PropTypes.func
}

export default PrivateSection
